var map = {
	"./angelusband2021.jpg": 11,
	"./dove.jpg": 12,
	"./live/00.jpg": 47,
	"./live/01.jpg": 48,
	"./live/02.jpg": 49,
	"./live/03.jpg": 50,
	"./live/04.jpg": 51,
	"./live/05.jpg": 52,
	"./live/06.jpg": 53,
	"./owl.jpg": 13,
	"./pin.jpg": 14,
	"./publicity/00.jpg": 54,
	"./publicity/01.jpg": 55,
	"./publicity/02.jpg": 56,
	"./publicity/03.jpg": 57,
	"./publicity/04.jpg": 58,
	"./publicity/05.jpg": 59,
	"./publicity/06.jpg": 60,
	"./publicity/07.jpg": 61,
	"./publicity/08.jpg": 62,
	"./publicity/09.jpg": 63,
	"./publicity/10.jpg": 64,
	"./publicity/11.jpg": 65,
	"./ram.jpg": 15,
	"./why_we_never_die.jpg": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;